import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MatSnackBar } from '@angular/material';
import { NgForm } from '@angular/forms';
import { DoctorService } from '../../services/doctor.service';
@Component({
  selector: 'app-addnewpet',
  templateUrl: './addnewpet.component.html',
  styleUrls: ['./addnewpet.component.css']
})
export class AddnewpetComponent implements OnInit {
  msg: string;
  name: any;
  type: any;
  rof: any;
  spid: any;
  smenu = [];
  sdetail = [];
  loading: any;
  action: any;
  dob: any;
  constructor(   private doctorService: DoctorService,
     private snackBar: MatSnackBar, private dialogRef: MatDialogRef <AddnewpetComponent>, 
     @Inject(MAT_DIALOG_DATA) public data: any) {
      this.spid = data.spid;
    }

  ngOnInit() {
    this.getdoctorServices();
  }
  getdoctorServices() {
    this.doctorService.getServiceMenu(this.spid)
    .subscribe (
      (x) => {
        this.loading = false;
        this.smenu = x;
        for (let i = 0; i  < this.smenu.length; i++ ) {
          this.getServicedetail(this.smenu[i].service_id)
        }
      });
  }
  getServicedetail(sid) {
    this.doctorService.getAllServices(sid)
    .subscribe(
      (x) => {
        if(x[0].name !== 'Text Chat' && x[0].name !== 'Video Chat'){
          this.sdetail.push(x[0]);
           }
      });
  }
  setformdetail() {
    if(!this.dob){
      this.dob ='0000-00-00';
    }
    console.log(this.dob);
    const result = {'name': this.name, 'type': this.type, 'dob': this.dob, 'reason': this.rof};
    this.dialogRef.close(result);
  }
  submitForm() {
    if (this.name === undefined && this.type === undefined && this.rof === undefined) {
      this.msg = 'Please Fill up All Detail';
      this.openSnackBar();
    } else if (this.type  === undefined) {
      this.msg = 'Please Fill up Pet Type';
      this.openSnackBar();
    } else if (this.name  === undefined) {
      this.msg = 'Please Fill up Pet name';
      this.openSnackBar();
    }else if (this.rof  === undefined) {
      this.msg = 'Please Fill up reson Of Appointment';
      this.openSnackBar();
    } else {
      this.setformdetail();
    }
  }
  openSnackBar() {
    this.snackBar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
}
